import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as UserActions from "./../actions/user_actions";
import * as FacilitiesActions from "./../actions/facilities_actions";
import * as PatientsActions from "./../actions/admin/patients_actions";
import * as AdminDashboardActions from "./../actions/admin/dashboard_actions";

import { ModalDialogCommon } from "./modal_dialog_common";
import { bindActionCreators } from "redux";
import { Loader } from "./loader";
import DayPickerInput from "react-day-picker/DayPickerInput";
import * as serviceCallConfig from "./../../src/config/api_urls";

// start - ResetPassword Component
let selectedFacilityId = 0;
let MultifacilitySelection = React.createClass({
  getInitialState() {
    return {
      showLoader: null,
      confimationModalMessage: null,
      clinicSelected: false,
      clinicName: "",
      selectedFromDay: null,
      selectedToDay: null,
      errorCsv: false,
      selectedFromDayDisplay: null,
      selectedToDayDisplay: null,
    };
  },
  componentWillMount() {},
  componentWillReceiveProps(nextProps) {
    // Admin Redirection
    if (
      nextProps.UserDetails &&
      nextProps.UserDetails.selectedUserRoleID === 2
    ) {
      this.props.router.push("/admin/dashboard");

      this.props.Dispatch(
        AdminDashboardActions.dashboardData(selectedFacilityId)
      );
      this.props.Dispatch(
        PatientsActions.getAllPaientsData(selectedFacilityId)
      );
      //  this.props.Dispatch(PatientsActions.getAllStaffData(facilitiesID));
      let loginid = nextProps.UserDetails.loginData.data.id;
      this.props.Dispatch(
        FacilitiesActions.getAdminUserById(loginid + "/" + selectedFacilityId)
      );
    }

    // Staff Redirection
    if (nextProps.UserDetails && nextProps.UserDetails.selectedUserRoleID > 2) {
      this.props.router.push("/patients");
    }
  },
  componentDidMount() {
    let clinicDate = new Date(this.props.UserDetails.facilitiCreatedDate);
    let clinicnewDate =
      clinicDate.getFullYear() +
      "-" +
      clinicDate.getMonth() +
      "-" +
      clinicDate.getDate();
    this.setState({ selectedFromDay: clinicnewDate });
  },

  closeBoxOnScuess() {
    this.setState({ okModalMsg: null });
  },
  selectClinic(event) {
    // console.log(event.currentTarget.dataset);
    // debugger;
    let roleID = parseInt(event.currentTarget.dataset.facilit_role_id);
    let f_id = parseInt(event.currentTarget.dataset.facilitid);

    this.props.Dispatch(UserActions.selectedUserRoleID(roleID));
    this.props.Dispatch(
      UserActions.facilitiCreatedDate(
        parseInt(event.currentTarget.dataset.createdate)
      )
    );
    selectedFacilityId = f_id;
    this.props.Dispatch(UserActions.selectedUserFacilityID(f_id));
    this.setState(
      { clinicName: event.currentTarget.dataset.clinicname },
      () => {
        this.props.Dispatch(
          UserActions.selectedClinicName(this.state.clinicName)
        );
        // console.log(this.state.clinicName);
      }
    );
    this.setState({ clinicSelected: true });
  },
  generateList: function () {
    var listData =
      this.props.UserDetails.loginData &&
      this.props.UserDetails.loginData.data.facilities;
    var styleli = { cursor: "pointer" };
    var list =
      listData &&
      listData.map(function (listItem, key) {
        return (
          <li
            key={key}
            style={styleli}
            data-createdate={listItem.facility.createdDate}
            data-facilit_role_id={listItem.role.id}
            data-facilitID={listItem.facility.id}
            data-clinicName={listItem.facility.name}
            onClick={this.selectClinic}
          >
            <div className="facility-item">
              <ul className="facility-item-holder">
                <li className="name">
                  <div
                    className="name-width"
                    data-facilit-id={listItem.facility.id}
                    onClick={this.props.viewAction}
                  >
                    <span
                      data-facilit-id={listItem.facility.id}
                      className="icon icon-hospital"
                    ></span>
                    {listItem.facility.name}
                  </div>
                </li>
                <li className="phone">
                  <div>
                    <span className="icon icon-phone"></span>
                    {listItem.facility.mobile}
                  </div>
                </li>
                <li className="email">
                  <div className="name-width">
                    <span className="icon icon-email"></span>
                    {listItem.facility.email}
                  </div>
                </li>{" "}
                <li className="add-admin">
                  <button
                    className="gray-button"
                    data-facilit_role_id={listItem.role.id}
                    data-facilitID={listItem.facility.id}
                    onClick={this.selectClinic}
                  >
                    Select Clinic
                  </button>
                </li>
              </ul>
            </div>
          </li>
        );
      }, this);
    if (listData && listData.length) {
      return list;
    } else {
      return [];
    }
  },
  genrateAdmiCsvReport() {
    let d = new Date();
    let data = "",
      facilityId =
        this.props.UserDetails.loginData &&
        this.props.UserDetails.loginData.data.id,
      reportType = this.refs.reportType.value, //1 or 2 1=staff 2= patient
      reportName =
        reportType === 1
          ? "Staff-report-"
          : reportType === 2
          ? "Patient-report-"
          : reportType === 3
          ? "RedFlag"
          : "Survey-report-",
      fromDate = this.state.selectedFromDay, //y-m-d
      toDate = this.state.selectedToDay, //y-m-d,
      name = reportName + fromDate + " to " + toDate; //m-d-y
    data = facilityId + "/" + reportType + "/" + fromDate + "/" + toDate;

    if (facilityId && reportType.length && fromDate && toDate) {
      window.open(
        serviceCallConfig.BASE_URL +
          serviceCallConfig.CSV_REPORT_ADMIN +
          "all/" +
          data
      );
      this.refs.reportType.value = "";
      this.setState({ selectedFromDay: "" });
      this.setState({ selectedToDay: "" });
    } else {
      this.setState({ errorCsv: true });
    }
  },
  handleFromDateChange(selectedDay, modifiers) {
    // debugger;
    let date = this.refs["from-date"].input.value.replace(/[^\w\s]/gi, "-");
    let ds = date.split("-");
    this.setState({ selectedFromDay: ds[2] + "-" + ds[0] + "-" + ds[1] });
    // this.setState({ selectedFromDayDisplay: ds[0] + "-" + ds[1] + "-" + ds[2] }); //yy-mm-dd
    let dateType = selectedDay._d;
    console.log(date, dateType, selectedDay._d, "date");
    this.setState({
      selectedFromDayDisplay:
        (dateType.getMonth() > 8
          ? dateType.getMonth() + 1
          : "0" + (dateType.getMonth() + 1)) +
        "/" +
        (dateType.getDate() > 9
          ? dateType.getDate()
          : "0" + dateType.getDate()) +
        "/" +
        dateType.getFullYear(),
    }); //YYYY-MM-DD
  },
  handleToDateChange(selectedDay, modifiers) {
    let date = this.refs["to-date"].input.value.replace(/[^\w\s]/gi, "-");
    let ds = date.split("-");
    this.setState({ selectedToDay: ds[2] + "-" + ds[0] + "-" + ds[1] });
    // this.setState({ selectedToDayDisplay: ds[0] + "-" + ds[1] + "-" + ds[2] });
    let dateType = selectedDay._d;
    console.log(date, dateType, selectedDay._d, "date");

    this.setState({
      selectedToDayDisplay:
        (dateType.getMonth() > 8
          ? dateType.getMonth() + 1
          : "0" + (dateType.getMonth() + 1)) +
        "/" +
        (dateType.getDate() > 9
          ? dateType.getDate()
          : "0" + dateType.getDate()) +
        "/" +
        dateType.getFullYear(),
    }); //YYYY-MM-DD
  },
  render() {
    let ClinicList = this.generateList();
    let h1Style = { marginBottom: "40px" };
    let clinicDate = new Date(this.props.UserDetails.facilitiCreatedDate);
    let clinicnewDate =
      (clinicDate.getMonth() > 8
        ? clinicDate.getMonth() + 1
        : "0" + (clinicDate.getMonth() + 1)) +
      "/" +
      (clinicDate.getDate() > 9
        ? clinicDate.getDate()
        : "0" + clinicDate.getDate()) +
      "/" +
      clinicDate.getFullYear();
    // let clinicnewDate = clinicDate.getMonth()+1+"-"+clinicDate.getDate()+"-"+clinicDate.getFullYear();
    let formDate = this.state.selectedFromDay
      ? this.state.selectedFromDayDisplay
      : clinicnewDate;
    let toDate = this.state.selectedToDay
      ? this.state.selectedToDayDisplay
      : "";
    const startDayPickerProps = {
      disabledDays: {
        before: new Date(clinicnewDate),
        after: new Date(),
      },
      selectedDays: new Date(2017, 1, 12),
    };
    const endDayPickerProps = {
      disabledDays: {
        before: new Date(this.state.selectedFromDay),
        after: new Date(),
      },
    };
    return (
      <div className="dashboard-inner-content container clinic-view">
        <div className="row">
          <h1 style={h1Style} className="text-center">
            Please select a clinic to proceed.
          </h1>
          <div className="col col-md-12 col-lg-12">
            <div className="facility-list-grid">
              <div className="grid-view" id="grid">
                <ul>{ClinicList}</ul>
              </div>
            </div>
          </div>
          <h1 style={h1Style} className="text-center d-none">
            Reports
          </h1>
          {this.props.UserDetails.loginData.data.facilities &&
            this.props.UserDetails.loginData.data.facilities[0].role.name !==
              "Super Admin" && (
              <div className="col-xs-6 padding-left-5 padding-right-none d-none">
                <div className="white-box generate">
                  <h3>REPORTS</h3>

                  <form className="Generate-form">
                    <div className="row">
                      <div className="col-xs-6 padding-left-none padding-right-none">
                        <div className="aj-dropdown">
                          <div className="source">
                            <div className="question-selection">
                              <select
                                required=""
                                ref="reportType"
                                onFocus={this.removeError}
                              >
                                <option value="" default="">
                                  Report Type
                                </option>
                                <option value="2">Patient Report</option>
                                <option value="1">Staff Report</option>
                                <option value="3">Red Flag Report</option>
                                <option value="4">Survey Report</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div className="generate-date">
                    <div
                      className="col-xs-6 padding-left-5 padding-right-none from-date"
                      onFocus={this.removeError}
                    >
                      <span className="">Start date : </span>
                      <DayPickerInput
                        readOnly
                        ref="from-date"
                        onDayChange={this.handleFromDateChange}
                        value={formDate}
                        format="M/D/YYYY"
                        dayPickerProps={startDayPickerProps}
                        selected={clinicDate}
                        placeholder="MM/DD/YYYY"
                      />
                    </div>

                    <div
                      className="col-xs-6 padding-left-5 padding-right-none to-date"
                      onFocus={this.removeError}
                    >
                      <span className="from ">End date : </span>
                      <DayPickerInput
                        readOnly
                        ref="to-date"
                        onDayChange={this.handleToDateChange}
                        value={toDate}
                        format="M/D/YYYY"
                        dayPickerProps={endDayPickerProps}
                        placeholder="MM/DD/YYYY"
                      />
                    </div>
                    <div className="clearfix"></div>
                  </div>
                </div>
                <div className="buttonSubmit">
                  <button
                    className="generateCsv"
                    onClick={this.genrateAdmiCsvReport}
                  >
                    Generate Csv
                  </button>
                </div>
                {this.state.errorCsv && (
                  <p className="error">
                    Please enter necessary fields to proceed.
                  </p>
                )}
              </div>
            )}
        </div>
      </div>
    );
  },
});

let mapStateToProps = (state) => {
  return {
    UserDetails: state.User,
    SessionLogoutResponse: state.User.sessionLogoutResponse,
  };
};

let mapDispatchToProps = (dispatch) => ({
  UserActions: bindActionCreators(UserActions, dispatch),
  Dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MultifacilitySelection));
// End - ResetPassword Componen



/** WEBPACK FOOTER **
 ** ./src/components/multi-facility-selection.jsx
 **/